import { useCallback, useMemo } from 'react'
import { EnumTipoDocumentoIdentidad, EnumTipoSujeto } from '../../api'
import { getTextSnippet } from '../../helpers/stringHelper'
import { validatePassport, validateSpanishId } from '../../helpers/validateDniHelper'
import { ClientFileModel, SubjectModel } from './clients.model'
import { ProvinceModel } from '../../api/Argentia/model/addresses'
import { enumEnumToValueNumber } from '../../helpers'

export const validateDocument = (doc: string, docType?: EnumTipoDocumentoIdentidad) => {
  let result = true
  if (doc === '' || !docType) {
    return result
  }

  if (docType === EnumTipoDocumentoIdentidad.NIE || docType === EnumTipoDocumentoIdentidad.NIF) {
    result = validateSpanishId(doc, docType)
  } else if (docType === EnumTipoDocumentoIdentidad.Pasaporte) {
    result = validatePassport(doc)
  }

  return result
}

export const validatePostalCode = (
  postalCode: string | undefined,
  provinceId: number | undefined,
  provinces: ProvinceModel[]
) => {
  let isValid = true

  if (postalCode && postalCode !== '' && provinceId) {
    const provinceCodePrefix = provinces.find(p => p.id === provinceId)?.postalCodeDesc
    isValid = postalCode.slice(0, 2) === provinceCodePrefix
  }

  return isValid
}

// Breadcrumb

export interface SubjectModelProps
  extends Omit<SubjectModel, 'name' | 'surname1' | 'surname2' | 'businessName'> {}

export interface PersonProps {
  name: string
  surname1: string
  surname2: string
  businessName?: never
}

export interface SubjectBusinessProps {
  businessName: string
  name?: never
  surname1?: never
  surname2?: never
}

export type SubjectProps =
  | SubjectModel
  | (Partial<SubjectModelProps> & (PersonProps | SubjectBusinessProps))

export const getLinkClientText = (subject: SubjectProps): string => {
  if (subject) {
    const textName = subject
      ? subject.businessName
        ? subject.businessName
        : `${subject.name ?? ''} ${subject.surname1 ?? ''} ${subject.surname2 ?? ''}`
      : ''
    return getTextSnippet(textName, 35)
  }

  return ''
}

export const getClientName = (clientData: ClientFileModel | undefined): string => {
  if (clientData) {
    if (clientData.businessName) {
      return clientData.businessName
    } else if (clientData.name || clientData.surname1 || clientData.surname2) {
      return `${clientData.name ?? ''} ${clientData.surname1 ?? ''} ${clientData.surname2 ?? ''}`
    } else if (clientData.description) {
      return clientData.description
    }
  }

  return ''
}

export const isSubjectCommercialOrWholesaler = (subjectType?: EnumTipoSujeto): boolean => {
  if (!subjectType) {
    return false
  }
  const type = enumEnumToValueNumber(EnumTipoSujeto, subjectType)

  return !type ? false : isSubjectCommercial(type) || isSubjectWholesaler(type)
}

export const isSubjectCommercial = (subjectType?: EnumTipoSujeto): boolean => {
  if (!subjectType) {
    return false
  }
  const type = enumEnumToValueNumber(EnumTipoSujeto, subjectType)

  return !type ? false : type === EnumTipoSujeto.Comercial
}

export const isSubjectFinalClient = (subjectType?: EnumTipoSujeto): boolean => {
  if (!subjectType) {
    return false
  }
  const type = enumEnumToValueNumber(EnumTipoSujeto, subjectType)

  return !type ? false : type === EnumTipoSujeto.ClienteFinal
}

export const isSubjectWholesaler = (subjectType?: EnumTipoSujeto): boolean => {
  if (!subjectType) {
    return false
  }
  const type = enumEnumToValueNumber(EnumTipoSujeto, subjectType)

  return !type ? false : type === EnumTipoSujeto.Mayorista
}

export const isSubjectExtendedClient = (subjectType?: EnumTipoSujeto): boolean => {
  if (!subjectType) {
    return false
  }
  const type = enumEnumToValueNumber(EnumTipoSujeto, subjectType)

  return !type ? false : type === EnumTipoSujeto.ClienteExtendido
}
